<template>
    <div class="mt-5 pt-5">
        <a-form layout="vertical" :form="form" class="mt-5">
            <a-row>
                <a-col :span="11">
                    <a-form-item label="单位名称：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                disabled
                                v-decorator="['enterpriseName',{initialValue:enterpriseName}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="统一社会信用代码：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                disabled
                                v-decorator="['enterpriseCode',{initialValue:enterpriseCode}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11">
                    <a-form-item label="注册资本(万元)：" :labelCol="labelCol" :wrapperCol="wrapperCol">
<!--                        <a-input-->
<!--                                v-decorator="['registerCapital',{initialValue:en.registerCapital,rules: [{ message: '注册资本格式不能为空',required: true},{ validator:registerCapitalValidate}]}]"-->
<!--                        />-->
                        <a-input-number
                                :min='0'
                                style="width: 390px;"
                                :precision="6"
                                v-decorator="['registerCapital',{initialValue:en.registerCapital,rules:[{ required: true, message: '注册资本不能为空'},{ validator: registerCapitalValidate}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="成立时间：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-date-picker format="YYYY-MM-DD"
                                       v-decorator="['foundDate',{initialValue:en.foundDate, rules: [{ required: true, message: '成立时间不能为空' },{validator:foundDateValidate}]}]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="11">
                    <a-form-item label="法定代表人：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['legalPerson',{initialValue:en.legalPerson, rules: [{required: true,message: '法人代表不能为空'}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="法人身份证号码：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['legalIdCard', {initialValue:en.legalIdCard ,rules: [{ required: true, message: '身份证不能为空'},{validator:iDCardValidate}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11">
                    <a-form-item class="t1-area" label="省/市/县：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <area-select type='all' size="small" :level='2' :data="pcaa" @change="change"
                                     v-model="selected"></area-select>
                    </a-form-item>
                    <a-form-item label="详细地址：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                :addon-before="complete"
                                v-decorator="['supplierAddress',{initialValue:en.supplierAddress ,rules: [{ required: true, message: '注册地址不能为空'}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="经营范围：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-textarea style="height: 100px;"
                                    v-decorator="['businessScope',{initialValue:en.businessScope,rules: [{ required: true, message: '经营范围不能为空'},{validator:scopeValidate}]}]"
                        >
                        </a-textarea>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="11">
                    <a-form-item label="联系人：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['contactsName',{initialValue:en.contactsName, rules: [{ required: true, message: '联系人不能为空'}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="联系人手机号：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['contactsPhone',{initialValue:en.contactsPhone ,rules: [{required: true,message: '联系人手机号不能为空'},{validator:phoneValidate}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11">
                    <a-form-item label="电子邮件：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['email',{initialValue:en.email, rules: [{ required: true, message: '邮箱不能为空'},{type: 'email',message: '邮箱格式不正确'}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="办公电话/传真：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['tel',{initialValue:en.tel,rules: [{type: 'string',message: '办公电话格式不正确', required: false}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="15">
                    <a-form-item  label="营业执照扫描件需盖公章:" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <span style="color: red;font-size: 10px;">只支持JPEG或JPG格式文件,最大2MB</span>
                        <upload-selector
                                :referId='en.cmtId'
                                ref="UploadSelector"
                                :max="2"
                                value="license"
                                configKey='UCARD' />
                    </a-form-item>
                </a-col>
            </a-row>
            <table style="width:100%" class="fx-form">
                <tr>
                    <td>
                    </td>
                </tr>
            </table>
            <a-form-item class="text-center">
                <a-button style="margin-left: 8px;width: 150px" @click="prevStep">上一步</a-button>
                <span> &nbsp;&nbsp;&nbsp;</span>
                <a-button style="width: 150px" :loading="loading" type="primary" @click="nextStep">提交</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
    import 'vue-area-linkage/dist/index.css'
    import {pca, pcaa} from 'area-data'
    import UploadSelector from '@/components/selector/UploadSelector'
    import moment from "moment";
    import DictCascader from '@/components/dict/DictCascader'
    import qs from "qs";

    export default {
        created() {
            console.log(this.enterpriseName+ "   "+ this.enterpriseCode)
            this.initData()
        },
        props:{
            enterpriseName: {
                type: String,
                default: ''
            },
            enterpriseCode: {
                type: String,
                default: ''
            }
        },
        components: {
            UploadSelector,
            moment,
            DictCascader
        },
        name: 'CorporateStep2',
        data () {
            return {
                labelCol: { lg: { span: 6 }, sm: { span: 6 } },
                wrapperCol: { lg: { span: 18 }, sm: { span: 18 } },
                form: this.$form.createForm(this),
                loading: false,
                timer: 0,
                pcaa: pcaa,
                small: 'small',
                city: '',
                province: '',
                district: '',
                cityName: '',
                provinceName: '',
                districtName: '',
                selected: [],
                en: '',
                complete:''
            }
        },
        methods: {
            initData() {
                let that = this
                this.$http.get("/api/v1/supplier/enterprise/init_certifications.json").then(function (res) {
                    console.log(res)
                    that.en = res.result
                    if (that.en.foundDate) {
                        that.en.foundDate = moment(that.en.foundDate)
                    }
                    that.selected = []

                    if (that.en.province) {
                        that.selected.push(that.pcaa[86][that.en.province])
                    }
                    if (that.en.province && that.en.city) {
                        that.selected.push(that.pcaa[that.en.province][that.en.city])
                    }
                    if (that.en.province && that.en.city && that.en.district) {
                        that.selected.push(that.pcaa[that.en.city][that.en.district])
                    }
                    if (that.en.registerCapital){
                        that.en.registerCapital = that.en.registerCapital + ""
                    }
                });
            },
            nextStep() {
                let params = {...this.form.getFieldsValue()}
                if (this.selected.length !== 3) {
                    this.$message.error('请选择省市县不能为空!')
                    return
                }
                for (var p in this.selected[0]) {
                    this.province = p
                    this.provinceName = this.selected[0][p]
                }
                for (var p in this.selected[1]) {
                    this.city = p
                    this.cityName = this.selected[1][p]
                }
                for (var p in this.selected[2]) {
                    this.district = p
                    this.districtName = this.selected[2][p]
                }
                if (this.cityName === '市辖区' ) {
                    params.registerAddress = this.provinceName  + this.districtName + params.supplierAddress
                }else {
                    params.registerAddress = this.provinceName + this.cityName + this.districtName + params.supplierAddress
                }
                let that = this
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    params.province = this.province
                    params.city = this.city
                    params.district = this.district
                    params.enterpriseId = this.en.enterpriseId
                    params.id = this.en.id

                    if (params.foundDate && params.foundDate != null) {
                        params.foundDate = params.foundDate.format("YYYY-MM-DD")
                    }

                    if (this.$refs.UploadSelector.uploadFiles && this.$refs.UploadSelector.uploadFiles.length < 1) {
                        that.$message.error("营业执照扫描件必须上传!")
                        return
                    }
                    that.doSubmit(params)
                })
            },
            doSubmit(params) {
                let that = this
                params.enterpriseCode = that.enterpriseCode
                params.enterpriseName = that.enterpriseName
                params.supplierType = '2'
                params.authType = '1'
                that.loading = true
                that.$http.post("/api/v1/supplier/enterprise/cmtCertificateInfo.json", qs.stringify(params, {allowDots: true})).then(function (res) {
                    if (res.code === 200) {
                        that.timer = setTimeout(function () {
                            that.loading = false
                            that.$emit('nextStep')
                        }, 1500)}
                })
            },
            change(e) {
                this.complete = ''
                var area = ''
                for (let i = 0; i < e.length; i++) {
                    var it = e[i]
                    console.log(it)
                    for (var p in it) {
                        area =  area + it[p]
                    }
                }
                if (area.indexOf("市辖区") != -1) {
                    area = area.replace("市辖区","")
                }
                this.complete = area
            },
            prevStep () {
                this.$emit('prevStep')
            },
            scopeValidate(rule, value, callback) {
                if (value && value.length > 500) {
                    callback("经营范围不能超过500字")
                }
                callback()
            },
            registerCapitalValidate(rule,value,callback) {
                var reg = /^\d+(\.\d+)?$/
                if (value && !reg.test(value)) {
                    callback("注册资本必须为整数")
                }
                if (value && value > 99999999.9999999) {
                    callback("注册资本必须小于8位")
                }
                callback();
            },
            foundDateValidate(rule,value,callback) {
                if (value && Date.parse(value) > new Date()) {
                    callback('注册时间必须早于当前时间')
                }
                callback()
            },
            iDCardValidate(rule, value, callback) {
                // var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                // if (value && !reg.test(value)) {
                //     callback("法人身份证格式不正确")
                // }
                callback()
            },
            phoneValidate(rule, value, callback) {
                // var reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
                var reg = /^[1][3-9][0-9]{9}$/
                if (value && !reg.test(value)) {
                    callback("手机号格式不正确")
                }
                callback()
            },
        },
        beforeDestroy () {
            clearTimeout(this.timer)
        }
    }
</script>

<style lang="less" scoped>
    .area-select-wrap{
        display: flex;
        justify-content: space-between;
        margin-top: 4px;
    }
    .area-select .area-selected-trigger {
        position: relative;
        display: block;
        font-size: 14px;
        cursor: pointer;
        margin: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 100%;
        padding: 0 12px;
        line-height: 30px;
        background: #000;
    }
    .area-select-wrap .area-select {
        margin-left: 0;
    }
    .area-select.small {
        width: 31%;
    }
</style>
